const pairData = [
    {
        id: 1,
        image: "https://bitcoin.org/img/icons/opengraph.png?1651392467",
        title: "BTC/USDT",
        amount: "56,838.39",
        type: "Bitcoin",
    },
    {
        id: 2,
        image: "https://s2.coinmarketcap.com/static/img/coins/200x200/52.png",
        title: "XRP/USDT",
        amount: "46,236.64",
        type: "Ripple",
    },
    {
        id: 3,
        image: "https://s2.coinmarketcap.com/static/img/coins/64x64/512.png",
        title: "XLM/USDT",
        amount: "46,236.64",
        type: "Stellar",
    },
    {
        id: 4,
        image: "https://s2.coinmarketcap.com/static/img/coins/64x64/4030.png",
        title: "ALGO/USDT",
        amount: "46,236.64",
        type: "Algorand",
    },
    {
        id: 5,
        image: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        title: "ETH/USDT",
        amount: "46,236.64",
        type: "Ethereum",
    },
];

export default pairData;